import { useMutation } from "react-query";
import {
  RelatorioPortariaFilter,
  RelatorioPortariaPdfResponse,
} from "../typings";
import { AxiosError } from "axios";
import http from "infra/http";

function useRelatorioPortariaPdf(query: RelatorioPortariaFilter) {
  return useMutation<RelatorioPortariaPdfResponse, AxiosError>(
    [`/v1/relatorios/portaria/pdf`, query],
    async () => {
      const { data } = await http.get<RelatorioPortariaPdfResponse>(
        "/v1/relatorios/portaria/pdf",
        {
          params: query,
        }
      );

      return data;
    }
  );
}

export default useRelatorioPortariaPdf;
